import { render, staticRenderFns } from "./MaterialDrawer.vue?vue&type=template&id=a909e34c&scoped=true&"
import script from "./MaterialDrawer.vue?vue&type=script&lang=js&"
export * from "./MaterialDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDrawer.vue?vue&type=style&index=0&id=a909e34c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a909e34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
